const useTrackEvent = () => {
  return (event_name, event_params) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event_name,
      ...event_params
    });
  };
}

export default useTrackEvent;